import { Box, Button, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid, Paper, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { IStipoPublicacaoOficial, TipoPublicacaoOficial, TipoPublicacaoOficialDTO } from '../../../../typesSite/tipoPublicacaoOficial/TipoPublicacaoOficial';
import { useAddTipoPublicacaoOficialMutation, useGetTipoPublicacaoOficialQuery } from './tipoPublicacaoOficialApiSlice';
import errorFormat from '../../../../utils/errorFormat';

export const TipoPublicacaoOficialCreate = () => {
  const [tipoPublicacaoOficial, SetTipoPublicacaoOficial] = useState<TipoPublicacaoOficial>(IStipoPublicacaoOficial);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [createTipoPublicacaoOficial, status] = useAddTipoPublicacaoOficialMutation();
  const navigate = useNavigate();

  //verificar se for edicao ele pega o id e faz a consulta
  const id = useParams().id || '';
  const { data, isFetching, error } = useGetTipoPublicacaoOficialQuery(id);
  useEffect(() => {
    if (data) {
      SetTipoPublicacaoOficial(data);
    }
  }, [data, error, isFetching]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const cursorPosition = e.target.selectionStart;

    SetTipoPublicacaoOficial(prev => ({
      ...prev,
      [name]: value
    }));

    // Aguarde até que o DOM seja atualizado
    setTimeout(() => {
      const input = e.target;
      input.setSelectionRange(cursorPosition, cursorPosition);
    }, 0);
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const parms: TipoPublicacaoOficialDTO = {
      id: tipoPublicacaoOficial.id || '',
      nome: tipoPublicacaoOficial.nome,
      descricao: tipoPublicacaoOficial.descricao || '',
      isVereador: tipoPublicacaoOficial.isVereador || false
    };
    await createTipoPublicacaoOficial(parms);
  }

  useEffect(() => {
    if (status.isError) {
      enqueueSnackbar('Registro não incluído!', { variant: 'error' });
      const erroReturn: string = errorFormat(status);
      enqueueSnackbar(erroReturn, { variant: 'error' });
    }

    if (status.isSuccess) {
      enqueueSnackbar('Registro incluído!', { variant: 'success' });
      navigate(-1);
      // setGrupo(ISgrupo);
    }
  }, [status]);

  return (
    <>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          mt: 4
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: {
              xs: '100%', // 100% em telas pequenas
              sm: '90%', // 90% em telas médias ou maiores
              md: '90%',
              lg: '90%'
            },
            maxWidth: '1200px', // Limite opcional
            p: 2
          }}
        >
          <Typography variant="h6" component="h1" sx={{ mb: 2 }}>
            {tipoPublicacaoOficial.id ? 'Edição' : 'Inclusão'} Tipo de Publicação Oficial
          </Typography>

          <form onSubmit={handleSubmit} method="POST">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField required label="Nome:" name="nome" onChange={handleChange} size="small" inputProps={{ maxLength: 50 }} value={tipoPublicacaoOficial.nome} />
                  <FormHelperText>{tipoPublicacaoOficial.nome?.length}/50 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControl fullWidth>
                  <TextField label="Descrição" name="descricao" multiline rows="4" onChange={handleChange} size="small" inputProps={{ maxLength: 255 }} value={tipoPublicacaoOficial.descricao} />
                  <FormHelperText>{tipoPublicacaoOficial.descricao?.length}/255 caracteres</FormHelperText>
                </FormControl>
              </Grid>

              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={tipoPublicacaoOficial.isVereador || false}
                      onChange={e =>
                        SetTipoPublicacaoOficial(prev => ({
                          ...prev,
                          isVereador: e.target.checked
                        }))
                      }
                      name="isVereador"
                      color="primary"
                    />
                  }
                  label="Deve informar Vereador?"
                />
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" gap={2}>
                  <Button type="submit" variant="contained" color="secondary">
                    Gravar
                  </Button>

                  <Button variant="contained" onClick={() => navigate(-1)}>
                    Voltar
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Box>
    </>
  );
};
